import React from "react";
import { store } from "../../redux/store/store";
import { urlDelPortal } from "../../helpers/zoco";
import { digitosDeWhatsapp } from "../../helpers/telefonoWhatsapp";

// Link del botón "Mensaje": abre Zoco Chat con el chat de ese teléfono, entrando por el pase del portal (la sesión de
// Zoco ya está abierta). Sin negocio (login propio de Tickets) no hay pase y queda el wa.me de siempre. null si el
// teléfono no tiene dígitos para marcar.
export const whatsappHref = (phone, name = "") => {
	const pelados = String(phone || "").replace(/[^0-9]/g, "");
	if (!pelados) return null;
	const negocioId = store.getState?.()?.auth?.negocio?.id;
	if (!negocioId) return `https://wa.me/${pelados}`;
	const nombre = String(name || "").trim();
	const volver = `/mensaje?telefono=${digitosDeWhatsapp(phone)}${nombre ? `&nombre=${encodeURIComponent(nombre)}` : ""}`;
	return urlDelPortal(`/api/auth/autorizar?producto=Chats&negocio=${encodeURIComponent(negocioId)}&volver=${encodeURIComponent(volver)}`);
};

// Link de "Gestionar plantillas en Zoco Chat": abre el gestor de plantillas de Chat en ese workspace, por el pase del
// portal, y Chat ofrece "Volver" a `volver` (por defecto la pantalla actual). null sin negocio (no hay pase).
export const plantillasChatHref = (workspaceId, volver = window.location.href) => {
	const negocioId = store.getState?.()?.auth?.negocio?.id;
	if (!negocioId || !workspaceId) return null;
	const rutaChat = `/settings/integrations?templates=whatsapp&workspace=${encodeURIComponent(workspaceId)}&volver=${encodeURIComponent(volver)}`;
	return urlDelPortal(`/api/auth/autorizar?producto=Chats&negocio=${encodeURIComponent(negocioId)}&volver=${encodeURIComponent(rutaChat)}`);
};

export function WhatsappIcon() {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M20.52 3.48A11.935 11.935 0 0 0 12 0C5.373 0 0 5.373 0 12c0 2.111.548 4.182 1.588 6.01L0 24l6.153-1.566A11.93 11.93 0 0 0 12 24c6.627 0 12-5.373 12-12 0-3.19-1.244-6.188-3.48-8.52ZM12 22.001a9.96 9.96 0 0 1-5.08-1.393l-.364-.214-3.633.925.97-3.54-.237-.372A9.957 9.957 0 0 1 2 12C2 6.486 6.486 2 12 2c2.668 0 5.182 1.04 7.07 2.929C20.96 6.818 22 9.332 22 12c0 5.514-4.486 10.001-10 10.001Zm5.204-7.58c-.285-.143-1.684-.83-1.944-.924-.26-.095-.45-.143-.64.143-.19.285-.734.924-.9 1.114-.167.19-.334.214-.62.071-.285-.143-1.204-.444-2.293-1.417-.848-.756-1.42-1.69-1.587-1.975-.167-.285-.018-.439.125-.582.128-.128.285-.334.428-.5.143-.167.19-.285.285-.476.095-.19.047-.357-.024-.5-.071-.143-.64-1.54-.876-2.11-.23-.553-.465-.478-.64-.486-.167-.008-.357-.01-.547-.01-.19 0-.5.071-.762.357-.262.285-1.002.978-1.002 2.386s1.026 2.768 1.169 2.957c.143.19 2.02 3.086 4.89 4.325.683.294 1.215.47 1.63.603.685.218 1.31.188 1.803.114.55-.082 1.684-.69 1.922-1.357.238-.666.238-1.237.167-1.357-.071-.119-.262-.19-.547-.333Z" />
		</svg>
	);
}

// "Mensaje" pill used on agenda cards. Renders nothing without a dialable phone.
// It sits next to (not inside) the card's open-detail button, but still stops the
// click so it never reaches a parent handler.
export function WhatsappLink({ phone, name, className = "odcg-item-wa" }) {
	const href = whatsappHref(phone, name);
	if (!href) return null;
	return (
		<a
			className={className}
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			aria-label={`Escribir por Zoco Chat a ${name}`}
			title={`Escribir por Zoco Chat a ${name}`}
			onClick={(event) => event.stopPropagation()}
		>
			<WhatsappIcon />
			<span>Mensaje</span>
		</a>
	);
}
